import { render, staticRenderFns } from "./ApothekeAllgemein.vue?vue&type=template&id=52edc93b&"
import script from "./ApothekeAllgemein.vue?vue&type=script&lang=js&"
export * from "./ApothekeAllgemein.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports